import * as zod from "zod/v4";

export const deleteCampaign = {
  name: "deleteCampaign" as const,
  input: zod.object({ campaignId: zod.string() }),
  output: zod.object({ success: zod.boolean() }),
};
